import { render, staticRenderFns } from "./TabsGroup.vue?vue&type=template&id=c7326ad4&"
import script from "./TabsGroup.vue?vue&type=script&lang=js&"
export * from "./TabsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports